import { StateCreator } from 'zustand';

import {
  CommonStoreType,
  ReferralProgramState,
} from '@/store/commonStore/types';

export const useReferralPageSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  ReferralProgramState
> = () => {
  return {
    referralProgramData: null,
    pendingReferralProgramData: true,
  };
};
